import assetService from "../../../../services/assetService/assetService";
import { useQuery } from "@tanstack/react-query";
import { CACHE_KEY_ASSETS } from "../../../../utils/constants";
import { AssetInterface } from "../../../../models/AssetModel/Asset";

const useAssetById = (id: string | undefined) =>
  useQuery<AssetInterface, Error>({
    queryKey: [`${CACHE_KEY_ASSETS}ById`, id],
    queryFn: ({ queryKey }) => {
      const [, incidentId] = queryKey;
      return assetService.GetById(incidentId as string);
    },
    enabled: !!id, // Only run the query if id is truthy (not undefined or an empty string)
  });

export default useAssetById;
